"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gatsby = require("gatsby");
var _excluded = ["title", "crumbs", "crumbLabel", "crumbSeparator", "disableLinks", "hiddenCrumbs"];
var AutoGenCrumb = function AutoGenCrumb(_ref) {
  var title = _ref.title,
    autoGenCrumbs = _ref.crumbs,
    crumbLabelOverride = _ref.crumbLabel,
    crumbSeparator = _ref.crumbSeparator,
    disableLinks = _ref.disableLinks,
    hiddenCrumbs = _ref.hiddenCrumbs,
    rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement("span", {
    className: "breadcrumb__title"
  }, title), /*#__PURE__*/_react.default.createElement("nav", {
    className: "breadcrumb",
    "aria-label": "Breadcrumb"
  }, /*#__PURE__*/_react.default.createElement("ol", {
    className: "breadcrumb__list"
  }, autoGenCrumbs.map(function (c, i) {
    if (hiddenCrumbs.includes(c.pathname)) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: i + "-" + c.pathname
    }, !disableLinks.includes(c.pathname) && /*#__PURE__*/_react.default.createElement("li", {
      className: "breadcrumb__list__item"
    }, /*#__PURE__*/_react.default.createElement(_gatsby.Link, (0, _extends2.default)({
      to: c.pathname,
      className: "breadcrumb__link",
      activeClassName: "breadcrumb__link__active",
      "aria-current": i === autoGenCrumbs.length - 1 ? 'page' : null
    }, rest), crumbLabelOverride && i === autoGenCrumbs.length - 1 ? crumbLabelOverride : c.crumbLabel)), disableLinks.includes(c.pathname) && /*#__PURE__*/_react.default.createElement("li", {
      className: "breadcrumb__list__item"
    }, /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({
      className: "breadcrumb__link__disabled"
    }, rest), crumbLabelOverride && i === autoGenCrumbs.length - 1 ? crumbLabelOverride : c.crumbLabel)), i === autoGenCrumbs.length - 1 ? null : /*#__PURE__*/_react.default.createElement("span", {
      className: "breadcrumb__separator",
      "aria-hidden": "true"
    }, crumbSeparator));
  }))));
};
AutoGenCrumb.defaultProps = {
  title: '',
  crumbSeparator: ' / ',
  crumbLabel: null,
  disableLinks: [],
  hiddenCrumbs: []
};
AutoGenCrumb.propTypes = {
  title: _propTypes.default.string,
  crumbSeparator: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  crumbs: _propTypes.default.arrayOf(_propTypes.default.shape({
    location: _propTypes.default.shape(),
    pathname: _propTypes.default.string.isRequired
  })).isRequired,
  crumbLabel: _propTypes.default.string,
  disableLinks: _propTypes.default.arrayOf(_propTypes.default.string),
  hiddenCrumbs: _propTypes.default.arrayOf(_propTypes.default.string)
};
var _default = AutoGenCrumb;
exports.default = _default;